<script>
    import { siteData } from './stores.js';

    let myTry;
    function toggleForm() {
        $siteData.showForm = true;
    };
    function checkPW() {
        if(myTry == $siteData.pw){
            $siteData.loggedIn = true;
        }
    }
</script>

<main>
    <div class="legend">
        <h1>
            Wat <br>de<br>Stufi<span on:click={toggleForm} class="creditlink">?!</span><br>💸
        </h1>
    </div>
    {#if $siteData.showForm}
        <input bind:value={myTry} on:input={checkPW} type="text">

    {/if}
</main>